var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"global-toast-fade"}},[(_vm.toastState.visible)?_c('div',{staticClass:"global-toast"},[_vm._v(_vm._s(_vm.toastState.message))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }